import React from 'react';
import { Landing } from './pages/Landing';
import { AppDemo } from './pages/AppDemo';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/app" element={<AppDemo />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;